type TLogo = {
  type?: 'banner' | 'logo';
  [x: string]: any;
};

export const Logo = ({ type = 'logo', ...props }: TLogo) => (
  <img
    src={
      type === 'logo' ? `assets\\icon\\logo.svg` : 'assets\\icon\\banner.svg'
    }
    className={props.className}
    alt=""
  />
);
